import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-2 text-left text-sm bg-primary5 border border-primary30 rounded-lg p-4"
}
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6",
  fill: "#2F7F91",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Já existe outra excepcionalidade aprovada nessa vaga. Uma nova aprovação irá sobrepor as regras da anterior ", -1)
const _hoisted_5 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-textSecondary" }, "Detalhes da exceção não disponíveis.", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "flex justify-around gap-4" }

import { computed } from 'vue'
import { mdiLock, mdiAlertCircleOutline } from '@mdi/js'
import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ExceptionSimpleCard from '../Cards/ExceptionSimpleCard.vue'
import ExceptionDetailsCard from '../Cards/ExceptionDetailsCard.vue'
import ExceptionWorkingDayCard from '../Cards/ExceptionWorkingDayCard.vue'
import { differenceInHours } from 'date-fns'

import {
  ExceptionSummary,
  ModalActionType
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { formatProportionalityRule, formatRepassMode } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionConfirmationSidebar',
  props: {
    isOpen: { type: Boolean },
    exception: {},
    loading: { type: Boolean },
    actionType: {},
    approvedExceptions: {},
    rejectedExceptions: {}
  },
  emits: ["update:isOpen", "confirmAction"],
  setup(__props: any, { emit }) {

const props = __props;





const modelValue = computed({
  get: () => props.isOpen,
  set: (value) => emit('update:isOpen', value)
})

const workJourneyLostHours = computed(() => {
  if (
    props.exception &&
    props.exception.changes.workJourney?.original &&
    props.exception.changes.workJourney?.requested
  ) {
    const originalStart = new Date(props.exception.changes.workJourney.original.startHour)
    const originalEnd = new Date(props.exception.changes.workJourney.original.endHour)
    const requestedStart = new Date(props.exception.changes.workJourney.requested.startHour)
    const requestedEnd = new Date(props.exception.changes.workJourney.requested.endHour)

    const originalDurationHours = differenceInHours(originalEnd, originalStart)
    const requestedDurationHours = differenceInHours(requestedEnd, requestedStart)
    const lost = originalDurationHours - requestedDurationHours
    return lost > 0 ? `${lost}h` : '0h'
  }
  return 'N/A'
})

const modalTitle = computed(() => {
  return props.actionType === ModalActionType.APPROVE
    ? 'Aprovar essa exceção?'
    : 'Reprovar essa exceção?'
})

const modalIcon = computed(() => {
  return props.actionType === ModalActionType.APPROVE ? undefined : mdiLock
})

const modalDescription = computed(() => {
  if (props.actionType === ModalActionType.APPROVE) {
    return 'Tem certeza que deseja aprovar esse pedido de excepcionalidade? Essa ação não poderá ser desfeita e afetará os atributos da vaga de plantão.'
  }
  return 'Tem certeza que deseja recusar esse pedido de excepcionalidade? Essa ação não poderá ser desfeita.'
})

const confirmButtonText = computed(() => {
  return props.actionType === ModalActionType.APPROVE ? 'Aprovar pedido' : 'Recusar pedido'
})

const confirmButtonClasses = computed(() => {
  return props.actionType === ModalActionType.APPROVE ? '!bg-primary30 mt-6' : '!bg-primary30 mt-6'
})

function closeModal() {
  emit('update:isOpen', false)
}

function confirmAction() {
  emit('confirmAction', props.actionType)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSidebar, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    title: modalTitle.value,
    icon: modalIcon.value,
    description: modalDescription.value
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(OutlinedButton, {
          text: "Voltar",
          width: "48%",
          class: "mt-6 !bg-white",
          "data-testid": "exception-confirmation-back-button",
          onClick: closeModal,
          height: "48px"
        }),
        _createVNode(FilledButton, {
          text: confirmButtonText.value,
          width: "48%",
          class: _normalizeClass(confirmButtonClasses.value),
          "data-testid": "exception-confirmation-confirm-button",
          onClick: confirmAction,
          loading: _ctx.loading,
          height: "48px"
        }, null, 8, ["text", "class", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.exception?.doctorStation.hasApprovedException)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                _createElementVNode("path", { d: _unref(mdiAlertCircleOutline) }, null, 8, _hoisted_3)
              ]))
            ]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (!_ctx.exception)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(ExceptionDetailsCard, {
              class: "mt-6",
              "request-date": _ctx.exception.requestDate,
              "request-id": _ctx.exception.id,
              "total-loss": Number(_ctx.exception.financials.estimatedLossTotal),
              "requester-name": _ctx.exception.requester.name,
              "approved-exceptions": _ctx.approvedExceptions,
              "rejected-exceptions": _ctx.rejectedExceptions
            }, null, 8, ["request-date", "request-id", "total-loss", "requester-name", "approved-exceptions", "rejected-exceptions"]),
            _createVNode(ExceptionSimpleCard, {
              class: "mt-4",
              title: "Modalidade de repasse",
              description: _unref(formatRepassMode)(_ctx.exception.changes.repassMode?.requested) || 'N/A'
            }, null, 8, ["description"]),
            _createVNode(ExceptionSimpleCard, {
              class: "mt-4",
              title: "Regras de proporcionalidade",
              description: 
          _unref(formatProportionalityRule)(_ctx.exception.changes.proportionalityRule?.requested) || 'N/A'
        
            }, null, 8, ["description"]),
            (
          _ctx.exception.changes.workJourney?.requested?.startHour &&
          _ctx.exception.changes.workJourney?.requested?.endHour
        )
              ? (_openBlock(), _createBlock(ExceptionWorkingDayCard, {
                  key: 0,
                  class: "mt-4",
                  "start-time": new Date(_ctx.exception.changes.workJourney.requested.startHour),
                  "end-time": new Date(_ctx.exception.changes.workJourney.requested.endHour),
                  "lost-hours": workJourneyLostHours.value,
                  "estimated-loss": Number(_ctx.exception.financials.estimatedLossTotal)
                }, null, 8, ["start-time", "end-time", "lost-hours", "estimated-loss"]))
              : _createCommentVNode("", true),
            _createVNode(ExceptionSimpleCard, {
              class: "mt-4",
              title: "Justificativa",
              description: _ctx.exception.justification || 'Nenhuma justificativa fornecida.'
            }, null, 8, ["description"])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title", "icon", "description"]))
}
}

})